// @flow

import React from "react";
import * as R from "ramda";

import Accordion from "src/components/Accordion.v2";
import AccordionContent from "src/components/Manage/Builder/Checklist/SettingsBuilder/FieldSettings/AdvancedApproval/AccordionContent";
import Automations from "../Automations";

import type { RevisionFieldSettingsv2 } from "src/types";

type Props = {
  settings: RevisionFieldSettingsv2,
  saveSettings: Function
};

const CurrentPrevious = ({ settings, saveSettings }: Props) => {
  const handleAutomation = (
    action:
      | "addParticipants"
      | "removeParticipants"
      | "addParticipantsFromFields"
      | "sendMessage"
      | "updatePrivacy"
      | "updateStatus"
      | "archive",
    data
  ) => {
    saveSettings(current => {
      const actionValue = current.automations["oldCurrent"];
      const index = R.findIndex(R.propEq("action", action))(actionValue);
      const currentAction = actionValue[index];
      const updatedAction = {
        ...currentAction,
        data
      };
      const mergeObj = {
        automations: {
          ["oldCurrent"]: R.update(index, updatedAction, actionValue)
        }
      };

      return R.mergeDeepRight(current, mergeObj);
    });
  };

  const handleStatus = (
    action:
      | "addParticipants"
      | "removeParticipants"
      | "addParticipantsFromFields"
      | "sendMessage"
      | "updatePrivacy"
      | "updateStatus"
      | "archive",
    active
  ) => {
    saveSettings(current => {
      const actionValue = current.automations["oldCurrent"];
      const index = R.findIndex(R.propEq("action", action))(actionValue);
      const currentAction = actionValue[index];
      const updatedAction = {
        ...currentAction,
        active
      };
      const mergeObj = {
        automations: {
          ["oldCurrent"]: R.update(index, updatedAction, actionValue)
        }
      };

      return R.mergeDeepRight(current, mergeObj);
    });
  };

  return (
    <Accordion title="For conversation that was currently previously">
      <AccordionContent>
        {settings.automations.oldCurrent.map((automation, index) => (
          <Automations
            key={index}
            value={automation.data}
            status={automation.active || false}
            action={automation.action}
            onChange={value => handleAutomation(automation.action, value)}
            onStatusChange={value => handleStatus(automation.action, value)}
          />
        ))}
      </AccordionContent>
    </Accordion>
  );
};

export default CurrentPrevious;
